module.exports = new __parcel__URL__("code-inspect-spot.ddd95706.svg").toString();